import React from 'react';
import { type IContextState, initialState } from './state';
import type { FetchNextPageOptions, InfiniteQueryObserverResult } from '@tanstack/react-query';
import type { IResponse, ISearch, IBookmarks } from '../types';

type IBookmarksPages = {
  nextCursor: number;
  pages: IResponse<IBookmarks> | null;
};

export interface IContext {
  state: IContextState;
  dispatch: React.Dispatch<any>;
  dispatchResult?: () => void;
  updateState?: (newState?: any) => void;
  setSelected?: (depth: number, id: string | number) => void;
  fetchNextPage?: (
    options?: FetchNextPageOptions | undefined,
  ) => Promise<
    InfiniteQueryObserverResult<IResponse<ISearch> | IBookmarksPages | null, unknown>
  > | void;
  setLoginStatus?: (status: boolean) => void;
}

export interface IResultContext extends IContext {
  fetchNextPage: (
    options?: FetchNextPageOptions | undefined,
  ) => Promise<InfiniteQueryObserverResult<IResponse<ISearch> | null, unknown>>;
  setLoginStatus: (status: boolean) => void;
  updateState: (newState: any) => void;
}

export interface IBookmarkContext extends IContext {
  setLoginStatus: (status: boolean) => void;
}

export interface IFilterContext extends IContext {
  dispatchResult: () => void;
  updateState: () => void;
}

export const DFContext = React.createContext<IContext>({
  state: initialState,
  dispatch: () => null,
});

export function useDfContext<T extends IContext = IContext>() {
  return React.useContext(DFContext) as T;
}
